import { get } from 'lodash';

export const getLassoSelectionMode = (state) =>
  get(state, 'LassoSelectionState.lassoMode', false);
export const getBlockOnClick = (state) =>
  get(state, 'LassoSelectionState.blockOnClick', false);



// WEBPACK FOOTER //
// ./src/common/Components/LassoSelection/state/selectors.js